import { api } from '../../../../../lib/api';

export const archiveCampaign = uuid => {
  return api.put(`/api/client_admin/campaigns/${uuid}/archive`, {});
};

export const unarchiveCampaign = uuid => {
  return api.put(`/api/client_admin/campaigns/${uuid}/unarchive`, {});
};

export const deleteCampaign = uuid => {
  return api.delete(`/api/client_admin/campaigns/${uuid}`);
};

export const restoreCampaign = uuid => {
  return api.put(`/api/client_admin/campaigns/${uuid}/restore`, {});
};

export const copyCampaign = (uuid, campaignData = {}) => {
  return api.post(`/api/client_admin/campaigns/${uuid}/copy`, {
    campaign: campaignData,
  });
};

export const createTemplate = uuid => {
  return api.post(`/api/v1/campaign_templates`, { campaign_uuid: uuid });
};

export const createCampaignPreview = uuid => {
  return api.post('/api/campaigns/previews', { id: uuid });
};

export const createCampaign = campaignData => {
  return api.post('/api/client_admin/campaigns', campaignData);
};
